import React from 'react';
import PrimaryButton from '../../../ui/PrimaryButton';
import TextButton from '../../../ui/TextButton';
import {useHistory} from 'react-router';

type ControlBlockProps = {
  loading: boolean
  disabled: boolean
}

/**
 * Submit and Cancel button at the end of custom field side form
 */
export default function ControlBlock({loading, disabled}: ControlBlockProps) {
  const history = useHistory();
  return (
    <>
      <PrimaryButton loading={loading} disabled={disabled}>Save changes</PrimaryButton>
      <TextButton onClick={(e) => {
        e.preventDefault();
        history.goBack();
      }}>Cancel</TextButton>
    </>
  );
}
